import { Avatar, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBadgeCheck } from '@fortawesome/pro-solid-svg-icons';
import { fromNow } from '../utils/dateTimeUtils';
import { Author } from '../../../../generated/graphql';
import { ActionMenu } from './ActionMenu';
import auth from '@client/components/auth';

type Props = {
  communityId: number;
  isUserCommunityOwner: boolean;
  author: Author;
  createdAt: Date;
  id: string;
  onDelete: () => void;
  onBlock: (communityId: number, userId: number) => void;
};

export const PostHeader = ({
  communityId,
  isUserCommunityOwner,
  author,
  createdAt,
  onDelete,
  onBlock,
}: Props) => {
  const isAdmin = auth.isAdministrator();
  const isAuthor: boolean = author.badges.includes('own');
  const isCreatorsPost: boolean = author.badges.includes('creator');
  const userId = author.id;
  const showBlockUser =
    ((isUserCommunityOwner && !isAuthor) || isAdmin) && !isCreatorsPost;

  return (
    <div className="flex justify-between items-center">
      <div className="flex items-center gap-2.5">
        <Avatar
          alt={author.username}
          src={author.profilePicture || ''}
          data-testid="avatar"
        />
        <div className="flex flex-col justify-center">
          <div className="flex gap-1.5 items-center">
            <Typography variant="h6" sx={{ fontWeight: 800 }}>
              {author.username}
            </Typography>
            {author.badges.includes('creator') && (
              <FontAwesomeIcon
                icon={faBadgeCheck}
                className="text-purple-1"
                data-testid="badge"
              />
            )}
          </div>
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: '0.75rem',
              lineHeight: '0.938rem',
            }}
          >
            {fromNow(createdAt)}
          </Typography>
        </div>
      </div>
      {(isUserCommunityOwner || isAuthor || isAdmin) && (
        <ActionMenu
          onDelete={onDelete}
          onBlock={() => onBlock(communityId, userId)}
          item="post"
          showBlockUser={showBlockUser}
        />
      )}
    </div>
  );
};
